export default '/src/assets/webgl/francesca_2/audios/outro.mp3'